
import { useWindowSize, useThrottle } from '@vueuse/core'

export default defineNuxtPlugin((nuxtApp) => {
  // Stores

  // Helpers
  const { width, height } = useWindowSize()

  const w = useThrottle(width, 150)
  const h = useThrottle(height, 150)

  // Provide
  return {
    provide: {
      viewport: {
        w,
        h,
      },
    },
  }
})
